import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import dayjs from 'dayjs';
import { formatBytes } from '../../utils/formatBytes';
import { CopyTextCell } from '../GridCells/CopyTextCell';

export const storedColumns: GridColDef[] = [
    { field: 'name', headerName: 'Log', width: 320, renderCell: CopyTextCell },
    { field: 'type', headerName: 'Log type', width: 110 },
    { field: 'filesCount', headerName: 'Files', type: 'number', width: 90 },
    {
        field: 'totalBytes',
        headerName: 'Size',
        width: 100,
        renderCell: (params) => <>{formatBytes(params.value)}</>,
    },
    {
        field: 'lastModified',
        headerName: 'Updated',
        width: 160,
        renderCell: (params) => <>{params.value ? dayjs(params.value).format('DD.MM.YYYY HH:mm') : ''}</>,
    },
];
